(function (window, document, $) {

    $(document).ready(function () {
        // cart aanpassingen
        if ($('.woocommerce-cart .cart__contents .cart-collaterals .related').length) {
            $('.woocommerce-cart .cart__contents .cart-collaterals .related h3 span').text('Cadeautje bij je bestelling');

            if ($('.woocommerce-cart .cart__contents .cart-collaterals .cross-sells').length) {
                $('.woocommerce-cart .cart__contents .cart-collaterals').append($('.woocommerce-cart .cart__contents .cart-collaterals .cross-sells'));
            }
        }

        // voeg password-requirements toe (hack)
        if ($('.woocommerce-checkout').length) {

            var $passRequirements = $('<p/>', {
                'html': '<em>Je wachtwoord moet minimaal een hoofdletter, cijfer en minstens 8 karakters bevatten.</em>',
                'css': { 'font-size': '13px' }
            });
            $('.woocommerce-checkout #um_account_password').after($passRequirements);

        }

        // Product variation prijs aanpassen ===========================================================================

        $('body').on('found_variation', function (event, variation) {
            $('span.product__price-regular').html($('.variation-price-' + variation["variation_id"]).html());
            $('.product__price-old').hide();
            $('.product__price-old-' + variation["variation_id"]).show();

            if (!variation["is_in_stock"]) {
                $('.woocommerce-variation-add-to-cart').hide();
                $('.out-of-stock-container').show();

            } else {
                $('.woocommerce-variation-add-to-cart').show();
                $('.out-of-stock-container').hide();
            }
        });

        // Betaalmethode shop standaard op iDeal =======================================================================

        if ($('.woocommerce-checkout-payment').length) {
            $("#payment_method_buckaroo_ideal").prop('checked', true);
        }
    });

}(window, document, jQuery));
